<template>
  <div
    class="pt-5 border-t border-gray-200 flex justify-between items-center w-full"
  >
    <button
      @click="changePage(currentPage - 1)"
      :disabled="currentPage === 1"
      class="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <ArrowLeft />
    </button>

    <div class="flex items-center gap-1">
      <button
        v-for="(page, index) in visiblePages"
        :key="index"
        @click="changePage(page)"
        :disabled="page === '...'"
        :class="[
          'w-10 h-10 rounded-lg text-sm flex items-center justify-center transition-colors',
          page === currentPage
            ? 'bg-gray-100 text-gray-900 font-bold'
            : page === '...'
            ? 'text-gray-500 cursor-default'
            : 'text-gray-600 hover:bg-gray-50',
        ]"
      >
        {{ page }}
      </button>
    </div>

    <button
      @click="changePage(currentPage + 1)"
      :disabled="currentPage === totalPages"
      class="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <ArrowRight />
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import ArrowLeft from "../icons/ArrowLeft.vue";
import ArrowRight from "../icons/ArrowRight.vue";

const props = defineProps({
  currentPage: {
    type: Number,
    required: true,
  },
  totalPages: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["update:currentPage"]);

const visiblePages = computed(() => {
  const pages = [];
  for (let i = 1; i <= props.totalPages; i++) {
    if (
      i === 1 ||
      i === props.totalPages ||
      (i >= props.currentPage - 1 && i <= props.currentPage + 1)
    ) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }
  return pages;
});

const changePage = (page) => {
  if (page !== "..." && page >= 1 && page <= props.totalPages) {
    emit("update:currentPage", page);
  }
};
</script>
